import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, scale, fill, spacing, rotation, gradient, verticalOffset }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  const leftTransformOrigin = '7.6078 3.9686'
  const rightTransformOrigin = '39.5111 3.9686'

  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g
        transform={`translate(${-spacing}) rotate(${rotation}) scale(${scale},${scale})`}
        transform-origin={leftTransformOrigin}
      >
        <path
          d="M0 4.68862C0 4.68862 12.78 5.28863 14.22 4.64863C15.66 4.00863 12.51 -0.811373 4.99001 1.94863C0.240005 3.69863 0 4.68862 0 4.68862Z"
          fill={`url(#${randomGradientId1})`}
        />
        <path
          d="M1.02979 3.96864C1.02979 3.96864 4.22979 2.19864 7.02979 2.02864C10.1998 1.83864 13.0798 3.20864 13.8398 2.87864C15.2798 2.23864 12.1798 -1.11136 5.40979 1.52864C2.59979 2.61864 1.02979 3.96864 1.02979 3.96864Z"
          fill={fill}
        />
      </g>
      <g
        transform={`translate(${spacing}) rotate(${-rotation}) scale(${scale},${scale})`}
        transform-origin={rightTransformOrigin}
      >
        <path
          d="M47.1192 4.68862C47.1192 4.68862 34.3392 5.28863 32.8992 4.64863C31.4592 4.00863 34.6092 -0.811373 42.1292 1.94863C46.8892 3.69863 47.1192 4.68862 47.1192 4.68862Z"
          fill={`url(#${randomGradientId2})`}
        />
        <path
          d="M46.0892 3.96864C46.0892 3.96864 42.8892 2.19864 40.0892 2.02864C36.9192 1.83864 34.0392 3.20864 33.2792 2.87864C31.8392 2.23864 34.9392 -1.11136 41.7092 1.52864C44.5192 2.61864 46.0892 3.96864 46.0892 3.96864Z"
          fill={fill}
        />
        <defs>
          <linearGradient
            id={randomGradientId1}
            x1="7.27992"
            y1="5.60814"
            x2="7.27992"
            y2="2.11731"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2877" stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8775" stopColor={gradient[0]} />
          </linearGradient>
          <linearGradient
            id={randomGradientId2}
            x1="39.8395"
            y1="5.60814"
            x2="39.8395"
            y2="2.11731"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2877" stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8775" stopColor={gradient[0]} />
          </linearGradient>
        </defs>
      </g>
    </g>
  )
}
